<template>
  <v-layout row wrap style="padding: 0 16px; margin-top: 1px;">
    <v-flex class="document-wrapper" xs12 v-if="documents.length > 0">
      <v-simple-table>
        <thead>
        <tr>
          <th class="text-left document-id-header">Id</th>
          <th class="text-left document-name-header">File</th>
          <th class="text-left document-type-header">Type</th>
          <th class="text-right document-action-header">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr xs12 v-for="(document, index) in documents" :key="index">
          <td class="document-id-cell">
            {{ document.id }}
          </td>
          <td class="document-name-cell">
            {{ document.fileName }}
          </td>
          <td class="document-type-cell">
            {{ document.documentType ? document.documentType.name : 'N/A'}}
          </td>
          <td class="text-right document-action-cell">
            <v-btn @click="getDocumentLink(document)" small icon>
              <v-icon color="accent">visibility</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-flex>
    <v-flex v-else>
      No Documents For Task
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DocumentList',
  computed: {
    ...mapGetters({
      documents: 'document/documentsByTask'
    })
  },
  methods: {
    ...mapActions({
      documentLink: 'document/getDocLink'
    }),
    async getDocumentLink (doc) {
      await this.documentLink(doc)
    }
  }
}
</script>
<style scoped>
  .document-wrapper {
    padding-top: 0 !important;
  }
  @media only screen and (max-width: 500px) {
    .document-id-cell,
    .document-id-header {
      padding: 0;
    }
    .document-name-cell,
    .document-type-cell,
    .document-type-cell,
    .document-name-header,
    .document-type-header {
      padding-left: 20px;
    }
    .document-action-cell,
    .document-action-header {
      padding: 0;
    }
  }
</style>
